// extracted by mini-css-extract-plugin
module.exports = {"no-results":"style_no-results__2isun"};